import { Component, Input } from "@angular/core";

@Component({
  selector: "ecert-icon",
  templateUrl: "./ecertnl-icon.component.html",
  styleUrls: ["./ecertnl-icon.component.css", "../../app.component.css"],
  standalone: false,
})
export class IconComponent {
  @Input() name: string;
  @Input() url: string;
  @Input() canHover: boolean = true;
  @Input() width: string = "32px";

  @Input()
  set hover(hover: boolean) {
    this._hover = hover;
  }

  private icon;
  private iconHover;
  private _hover;

  ngOnInit() {
    /*this.icon = require("../../../../../assets/icons/" + this.name + ".svg");
        if(this.canHover)
            this.iconHover = require("../../../../../assets/icons/" + this.name + "-hover-focus.svg");
        this.src = this.icon;*/
  }

  get src() {
    if (this.url != null) {
      return this.url;
    }

    let src = "assets/icons/" + this.name + ".svg";
    if (this._hover && this.canHover) {
      src = "assets/icons/" + this.name + "-hover-focus.svg";
    }
    return src;
  }
}
